module.exports = Em.Controller.extend({
    needs: ['organization'],
    organization: Em.computed.oneWay('controllers.organization.model')
})
